import { render, staticRenderFns } from "./OrganizationsExportPage.vue?vue&type=template&id=12b3fc86&"
import script from "./OrganizationsExportPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationsExportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports